import React from 'react';
import { Box, Heading, Text, Card, Flex, Badge } from '@radix-ui/themes';
import { EnvelopeClosedIcon } from '@radix-ui/react-icons';

const NotificationList: React.FC = () => {
  return (
    <Box>
      <Box pb="4" px="1">
        <Flex align="center" gap="3">
          <Box
            style={{
              padding: '8px',
              borderRadius: '8px',
              backgroundColor: 'var(--blue-3)',
              color: 'var(--blue-11)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <EnvelopeClosedIcon width={24} height={24} />
          </Box>
          <Box>
            <Flex align="center" gap="2">
              <Heading as="h1" size="5" weight="bold">
                Notifications
              </Heading>
              <Badge color="blue" variant="soft" size="1">
                Coming Soon
              </Badge>
            </Flex>
            <Text size="2" color="gray">
              View and manage your in-app notifications
            </Text>
          </Box>
        </Flex>
      </Box>

      <Card size="2">
        <Flex direction="column" align="center" justify="center" gap="4" py="9">
          <Box
            style={{
              padding: '24px',
              borderRadius: '50%',
              backgroundColor: 'var(--blue-3)',
              color: 'var(--blue-9)',
            }}
          >
            <EnvelopeClosedIcon width={48} height={48} />
          </Box>
          <Box style={{ textAlign: 'center', maxWidth: '400px' }}>
            <Heading as="h3" size="4" weight="medium" mb="2">
              In-App Notifications
            </Heading>
            <Text size="2" color="gray">
              This feature is coming soon. You&apos;ll be able to receive alert
              notifications directly in the app, view your notification history,
              and manage your notification preferences.
            </Text>
          </Box>
        </Flex>
      </Card>
    </Box>
  );
};

export default NotificationList;
